module.exports = __webpack_public_path__ + "media/Blob 5 Joins.fdf8a090.mp3";